<div class="loader-container">
  <div class="overlay">
    <img src="assets/Loading-animation.gif" class="spinner" alt="loading animation"/>
  </div>
</div>
